module.exports = __webpack_public_path__ + "static/klee-selected-b6e53794a467794182485bb7516aee72.png";